import { Target } from 'lucide-react'
import type { EmpresaDetailed } from '@/types'
import { formatCurrency } from '@/utils/format-currency'

interface EmpresaDealsTabProps {
  empresa: EmpresaDetailed
}

export function EmpresaDealsTab({ empresa }: EmpresaDealsTabProps) {
  const deals = empresa.deals as { id: string; nome?: string; title?: string; valor?: number; value?: number; etapa?: string; stage?: string }[] | undefined

  if (!deals || deals.length === 0) {
    return (
      <div className='p-8 text-center'>
        <Target size={48} className='mx-auto mb-3 text-[var(--text-muted)] opacity-50' />
        <p className='text-[var(--font-color-body)] font-medium'>Nenhum deal encontrado</p>
        <p className='text-[var(--font-color-muted)] text-sm mt-1'>
          Deals vinculados a esta empresa aparecerão aqui
        </p>
      </div>
    )
  }

  return (
    <div className='space-y-2'>
      {deals.map((deal) => (
        <div
          key={deal.id}
          className='flex items-center justify-between p-3 rounded-lg hover:bg-[var(--glass-bg)] transition-colors cursor-pointer'
        >
          <div>
            <p
              className='font-medium text-[var(--font-color-body)]'
              style={{ fontSize: 'var(--font-size-sm)' }}
            >
              {deal.nome ?? deal.title ?? 'Sem nome'}
            </p>
            <p
              className='text-[var(--font-color-muted)]'
              style={{ fontSize: 'var(--font-size-xs)' }}
            >
              {deal.etapa ?? deal.stage ?? '—'}
            </p>
          </div>
          <span
            className='font-semibold text-[var(--font-color-body)]'
            style={{ fontSize: 'var(--font-size-sm)' }}
          >
            {formatCurrency(deal.valor ?? deal.value ?? 0)}
          </span>
        </div>
      ))}
    </div>
  )
}
